var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"fixed":"","app":""}},[_c('v-card',{staticClass:"flex gradient2"},[_c('v-card-actions',[_c('span',{staticClass:"white--text ml-auto"},[_vm._v("\n        © 2018 -\n        "),_c('strong',[_vm._v("Ittention")])])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }